import React from "react";
import Head from "next/head";
import styled from "styled-components";
import Layout from "components/Layout";
import { Container } from "components/Grid";
import CategoryTile from "components/CategoryTile";
import * as Navigation from "lib/models/Navigation";
import withGlobalFields from "lib/withGlobalFields";

const Content = styled.div`
  padding: 2rem 0;
`;

const Title = styled.h1`
  font-size: 3rem;
`;

const SubTitle = styled.p`
  font-size: 1.8rem;
  margin-bottom: 2rem;
`;

const List = styled.ul`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -1.5rem;
`;

const ListItem = styled.li`
  flex: 0 1 100%;
  padding: 0 1.5rem;

  @media (min-width: 640px) {
    flex: 0 1 50%;
  }

  @media (min-width: 992px) {
    flex: 0 1 33.33%;
  }
`;

const Category = (props) => {
  return (
    <Layout {...props.global}>
      <Head>
        <title>{`${props.title} | ${props.global.seo.title}`}</title>
      </Head>

      <Content>
        <Container>
          <Title>{props.title}</Title>
          <SubTitle>Select a category to find relevant quizzes:</SubTitle>

          <List>
            {props.categories.map((category) => (
              <ListItem key={category.id}>
                <CategoryTile category={props.slug} {...category} />
              </ListItem>
            ))}
          </List>
        </Container>
      </Content>
    </Layout>
  );
};

export const getServerSideProps = withGlobalFields(async ({ params }) => {
  const category = await Navigation.getBySlug(params.category);

  if (!category) return { notFound: true };

  const categories = await Navigation.getCategories(category.id, [
    "title",
    "slug",
    "mainQuiz",
  ]);

  return { props: { ...category, categories } };
});

export default Category;
